const businessPageTitle = (t, titleKey) => {
  return `${t(titleKey)} - ${t('business:mmhmmForBusiness')}`
}

export default businessPageTitle
